export const SALARY_DEVIATIONS_SUBMITTED = "SALARY_DEVIATIONS_SUBMITTED";
export const SALARY_DEVIATIONS_WITH_BUSINESSUNITS_SUBMITTED = "SALARY_DEVIATIONS_WITH_BUSINESSUNITS_SUBMITTED";
export const WINT_SALARY_APPROVAL_REPORT_SUBMITTED = "WINT_SALARY_APPROVAL_REPORT_SUBMITTED";
